export default __webpack_public_path__ + "src/scripts/vue/assets/icon_finished.svg";